<template>
  <MessageLayout :title="title" :errorcode="errorcode" class="error-message">
    <template v-slot:image>
      <div class="error-message__header">
        <img
          :src="`${config.publicPath}triangle-warning.svg`"
          alt="warning"
          class="error-message__image"
        />
        <div class="error-message__errorcode">
          {{ errorcode }}
        </div>
      </div>
    </template>
    Oops! Something went wrong: nobody said 100% reliability.
    <template v-slot:action>
      <el-button @click="tryAgain">Try Again</el-button>
    </template>
  </MessageLayout>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { configService } from "@/services/config-service";
import MessageLayout from "@/modules/messages/MessageLayout.vue";

@Options({
  components: {
    MessageLayout,
  },
  props: {
    image: String,
    title: String,
    errorcode: String,
  },
})
export default class ErrorMessageLayout extends Vue {
  config = configService;
}
</script>

<style lang="scss" scoped>
.error-message {
  max-width: 480px;
  margin: 10px auto;

  &__header {
    font-size: 80px;
    position: relative;
    left: 25%;
  }

  &__image {
    width: 53px;
    height: 44px;
    margin: 39px auto auto 120px;
    display: block;
    position: absolute;
    z-index: 1;
  }

  &__errorcode {
    font-weight: bold;
    z-index: 2;
    margin-bottom: 54px;
  }
}
</style>
